module.exports = __webpack_public_path__ + "img/sphone_choose.087db324.png";